<template>
  <div class="footer">
    <div class="footer-main">
      <div class="footer-main-box1">
        <img src="../assets/img/erj.png" />
        <div>
          <div class="footer-main-service">客服电话</div>
          <div class="footer-main-service">周一至周五 8:30-18:00</div>
          <div class="footer-main-phone">17869832853</div>
          <div class="footer-main-phone">18187317894</div>
          <div class="footer-main-phone">微信同号</div>
        </div>
      </div>
      <div class="footer-main-box2">
        <div>
          <div class="footer-title">课程</div>
<!--          <div class="footer-text" @click="goCurriculumSetMeal">课程中心</div>-->
          <div class="footer-text" @click="handletoClasses">听课</div>
        </div>
<!--        <div v-if="newsList.length > 0">-->
<!--          <div-->
<!--            class="footer-title"-->
<!--            style="cursor: pointer"-->
<!--            @click.stop="handletoNews"-->
<!--          >-->
<!--            新闻资讯-->
<!--          </div>-->
<!--          <div-->
<!--            v-if="newsList[0]"-->
<!--            class="footer-text"-->
<!--            @click.stop="handleToNewsDetail(0)"-->
<!--          >-->
<!--            新闻一-->
<!--          </div>-->
<!--          <div-->
<!--            v-if="newsList[1]"-->
<!--            class="footer-text"-->
<!--            @click.stop="handleToNewsDetail(1)"-->
<!--          >-->
<!--            新闻二-->
<!--          </div>-->
<!--        </div>-->
<!--        <div v-if="helpList.length > 0">-->
<!--          <div-->
<!--            class="footer-title"-->
<!--            @click.stop="handleToHelp"-->
<!--            style="cursor: pointer"-->
<!--          >-->
<!--            帮助中心-->
<!--          </div>-->
<!--          <div-->
<!--            class="footer-text"-->
<!--            v-for="item in helpList"-->
<!--            :key="item.id"-->
<!--            @click.stop="handleToHelpDetail(item.content)"-->
<!--          >-->
<!--            {{ item.title }}-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="footer-main-box3">
        <div style="margin-right: 50px;">
          <img class="footer-code" src="../assets/img/jxjykf.jpg" />
          <div class="footer-code-test">添加客服微信号</div>
          <!-- <div class="footer-code-test">（福利多多）</div> -->
        </div>
        <div style="margin-right: 50px;">
          <img class="footer-code" src="../assets/img/wyfwx.jpg" />
          <div class="footer-code-test">添加客服微信号</div>
          <!-- <div class="footer-code-test">（福利多多）</div> -->
        </div>
        <div style="margin-right: 50px; width: ;">
          <img class="footer-code" src="../assets/img/android.png" />
          <div class="footer-code-test">扫码下载安卓版</div>
          <div class="footer-code-test">（更多精彩）</div>
        </div>
		<div>
		  <img class="footer-code" src="../assets/img/ios.png" />
		  <div class="footer-code-test">扫码下载ios版</div>yu
		  <div class="footer-code-test">（更多精彩）</div>
		</div>
      </div>
    </div>
    <div class="footer-bottom">
      滇公网安备 53010202000645号
      <!-- <span style="margin-left: 20px;">技术支持：云南十点科技</span> -->
    </div>
  </div>
</template>

<script>
import { postData, EventBus } from "../assets/api/api.js";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      helpList: [],
      newsList: [],
    };
  },
  created() {
    this.loadHelpData();
    this.loadNewsData();
  },
  computed: {
    master() {
      return this.$store.state.master;
    },
  },
  mounted() {},
  methods: {
    loadHelpData() {
      postData("system_article/list", {}).then((res) => {
        this.helpList = res.data.content.slice(0, 4);
      });
    },
    // 读取新闻数据
    loadNewsData() {
      var params = {
        currentPage: 0,
        pageSize: 2,
      };
      postData("article/listPage", params).then((res) => {
        if (res.data) {
          if (res.data.entities) {
            this.newsList = res.data.entities;
          } else {
            this.newsList = [];
          }
        } else {
          this.newsList = [];
        }
      });
    },
    handletoNews() {
      this.$router.push({
        path: "/news",
      });
    },
    handleToNewsDetail(item) {
      if (this.$route.path == "/newsDetail") {
        if (item == 0) {
          EventBus.$emit("handleChangeDetail", this.newsList[0].id);
        } else {
          EventBus.$emit("handleChangeDetail", this.newsList[1].id);
        }
      } else {
        if (item == 0) {
          this.$router.push({
            path: "/newsDetail",
            query: { id: this.newsList[0].id },
          });
        } else {
          this.$router.push({
            path: "/newsDetail",
            query: { id: this.newsList[1].id },
          });
        }
      }
    },
    goCurriculumSetMeal() {
      if (!this.master.token.token) {
        EventBus.$emit("login");
        this.$Message.warning("请登录");
        return;
      }
      this.$router.push({
        name: "CurriculumSetMeal",
      });
    },
    handletoClasses() {
      if (!this.master.token.token) {
        EventBus.$emit("login");
        this.$Message.warning("请登录");
        return;
      }
      if (!this.$store.state.master.user.phone) {
        this.$router.push({
          path: "/bindPhone",
        });
      } else {
        this.$router.push({
          path: "/attendanceProcess/combo",
        });
      }
    },
    handleToHelpDetail(content) {
      if (this.$route.path == "/help/helpDetail") {
        EventBus.$emit("handleChangeHelp", content);
      } else {
        this.$router.push({
          name: "HelpDetail",
          params: { content: content },
        });
      }
    },
    handleToHelp() {
      this.$router.push({
        path: "/help/helpList",
      });
    },
  },
};
</script>

<style lang="scss">
.footer {
  background: #222222;
  height: 270px;
  &-main {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 220px;
    &-box1 {
      display: flex;
      align-items: center;
      img {
        margin-right: 12px;
      }
    }
    &-service {
      font-size: 15px;
      color: #777777;
    }
    &-phone {
      font-size: 20px;
      font-weight: bold;
      color: #fff;
    }
    &-box2 {
      margin-left: 28px;
      width: 422px;
      display: flex;
      border-left: 1px solid #333333;
      border-right: 1px solid #333333;
      padding-top: 40px;
      padding-left: 40px;
      padding-right: 33px;
      justify-content: space-between;
    }
    &-box3 {
      display: flex;
      margin-left: 56px;
      padding-top: 28px;
    }
  }
  &-title {
    font-size: 16px;
    color: #fff;
    margin-bottom: 25px;
    line-height: 1;
  }
  &-text {
    color: #666666;
    font-size: 14px;
    margin-bottom: 12px;
    line-height: 1;
    cursor: pointer;
  }
  &-text:hover {
    color: #b9aeae;
  }
  &-code {
    width: 120px;
    height: 120px;
    margin-bottom: 15px;
    &-test {
      font-size: 14px;
      color: #fff;
      line-height: 1;
      text-align: center;
      margin-bottom: 5px;
    }
  }
  &-bottom {
    border-top: 1px solid #333;
    text-align: center;
    line-height: 48px;
    color: #666666;
    font-size: 13px;
  }
}
</style>
